import React, { useState, useEffect, useRef } from "react";
import { FileText, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router";
import { ROUTES } from "@/constant/routes";

const FloatingCTA = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isVisible, _] = useState(true);
    const navigate = useNavigate();
    const containerRef = useRef(null);

    // Handle click outside to close the expanded card
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsExpanded(false);
            }
        };

        if (isExpanded) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isExpanded]);

    if (!isVisible) return null;

    const handleProposalClick = () => {
        setIsExpanded(false);
        navigate(ROUTES.CONTACT);
    };

    return (
        <div ref={containerRef} className="fixed bottom-4 left-4 z-50 hidden sm:flex flex-col items-start gap-2">
            <AnimatePresence>
                {isExpanded && (
                    <motion.div
                        initial={{ opacity: 0, y: 20, scale: 0.9 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 20, scale: 0.9 }}
                        className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 mb-2 max-w-xs"
                    >
                        <div className="flex justify-between items-start mb-2">
                            <h3 className="font-bold text-gray-900 dark:text-white">
                                Ready to grow?
                            </h3>
                            <button
                                onClick={() => setIsExpanded(false)}
                                className="text-gray-400 hover:text-gray-600"
                            >
                                <X className="h-4 w-4" />
                            </button>
                        </div>
                        <p className="text-sm text-gray-600 dark:text-gray-300 mb-3">
                            Get a custom proposal for your project in less than 24 hours.
                        </p>
                        <Button
                            size="sm"
                            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white"
                            onClick={handleProposalClick}
                        >
                            Get Free Proposal
                        </Button>
                    </motion.div>
                )}
            </AnimatePresence>

            <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setIsExpanded(!isExpanded)}
                className="group flex items-center gap-2 bg-white dark:bg-gray-800 text-gray-900 dark:text-white px-4 py-3 rounded-full shadow-lg border border-gray-200 dark:border-gray-700 hover:shadow-xl transition-all"
            >
                <div className="relative">
                    <FileText className="h-5 w-5 text-blue-600" />
                    <span className="absolute -top-1 -right-1 flex h-3 w-3">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-3 w-3 bg-blue-500"></span>
                    </span>
                </div>
                <span className="font-medium">Get Proposal</span>
            </motion.button>
        </div>
    );
};

export default FloatingCTA;
